import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { FieldConfig, Validator } from "../../interface/field.interface";
import { CommonService } from 'src/app/Service/Common.service';
import { EIPAutoCompleteComponent } from "eipauto-complete";

@Component({
  selector: 'form-field-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit, AfterViewInit {
  field: FieldConfig | any;
  group!: FormGroup;
  formName: string = '';
  formFieldName!: string;
  selectedDedId!: number;
  controlId!: string;
  waterMarkText: string | any;
  @ViewChild(EIPAutoCompleteComponent)
  autoCompleteComponent!: EIPAutoCompleteComponent;
  constructor(private _projectService: ProjectInfoService, private commonService: CommonService) { }

  ngOnInit() {
    this.formFieldName = "form" + this.field.name;
    this.controlId = this.formFieldName + Date.now().toString();
    this.waterMarkText = this.isMandatory() ? this.field.name + " * " : this.field.name;
  }

  ngAfterViewInit(): void {
    this.bindElementDetails();
    //Update selected value, whenever dedId changes
    if (!!this.field.value) {
      this.field.value.subscribe((dedId: number) => {
        if (!!dedId && !!this.field.values && this.field.values.length > 0 && dedId > 0) {
          let selectedValue: IProjectElementDetailsOutput | any = this.field.values.find((x: { dedId: number; }) => x.dedId == dedId);
          if (!!selectedValue) {
            this.selectedDedId = selectedValue.dedId;
            this.group.get(this.formFieldName)?.setValue(this.selectedDedId);
          }
        }
      });
    }
  }

  bindElementDetails() {
    this._projectService.getProjectElementDetails({
      projectId: this.commonService.getProjectId(),
      groupId: this.commonService.getLoggedInUserGroupId(), moduleId: this.field.module_id,
      deId: this.field.de_id, deDescription: this.field.deDescription, memberId: this.commonService.getLoggedInUserId()
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
      this.field.values = res;
      //Update selected value, whenever dedId changes
      if (!!this.field.value) {
        let selectedDedId: any = this.field.value.value;
        if (!!selectedDedId && selectedDedId > 0) {
          this.field.value.next(selectedDedId)
        }
        else if (res.length == 1) {
          this.selectedDedId = this.field.values[0].dedId;
          this.group.get(this.formFieldName)?.setValue(this.selectedDedId);
        }
      }
      else if (res.length == 1) {
        this.selectedDedId = this.field.values[0].dedId;
        this.group.get(this.formFieldName)?.setValue(this.selectedDedId);
      }
    }, err => { });
  }

  isMandatory(): string | null {
    if (this.field.validations && this.field.validations.length > 0) {
      let requiredValidator: Validator | any = this.field.validations.find((x: { name: string; }) => x.name == 'required')
      if (requiredValidator)
        return 'required';
    }
    return null;
  }

  onselectedValueChange(val: any) {
    if (val.value != "-2") {
      this.group.get(this.field.name)?.setValue(val.additionalValues.additionalValues);
    } else if (val.value == "-2") {
      this.group.get(this.field.name)?.setValue(undefined);
    }
  }
}
